import { GlobalState } from "../global.store";

export const selectAudiobook = (state: GlobalState) => {
  return state.audiobook;
};
